export const WORKSHOPS = [
  {
    id: "kings-dog-daycare-monthly",
    name: "Flower Arranging Workshop",
    place: "King's Dog Daycare",
    address: "177 Fulham Road, Chelsea, London SW3 6JW",
    date: "Monthly",
    time: "1pm",
    duration: "60-90 mins",
    price: 45,
    description: "Relax with dogs and enjoy a creative afternoon of flower arranging. Whether you're a complete beginner or just looking for something different, this laid-back workshop is for you. Bring your furry friend along and make something beautiful together. All levels welcome - come meet like-minded people and leave with a gorgeous bouquet.",
    seasonalDescription: "Spend a crisp October Saturday surrounded by wagging tails and autumnal blooms. Arrange seasonal stems in the company of the daycare dogs, sip a warm drink from the café, and craft a bouquet with just the right touch of spooky charm. A laid-back afternoon for beginners and seasoned arrangers alike.",
    upcomingDates: [
      { date: "31st October 2026", day: "Saturday", time: "1pm", bookingUrl: "https://kingsdogdaycare.replit.app/events/9" },
    ],
    included: ["Your bouquet to take home", "Any drink from café", "Dog treats", "Dog toy", "Puppuccino", "Puppy playtime"],
    accent: "#B8926A",
    image: "https://lh3.googleusercontent.com/d/1nn9kxXoLR3anx-Zt_EnVM7-XS0l1tVgH=w800",
    seasonalImage: "https://lh3.googleusercontent.com/d/1nn9kxXoLR3anx-Zt_EnVM7-XS0l1tVgH=w800",
    bookingType: "external",
    bookingUrl: "https://kingsdogdaycare.replit.app/events/9",
    status: "live",
  },
  {
    id: "paws-cat-cafe-2026-06-26",
    name: "Flower Arranging Workshop",
    place: "Alfi Spitalfields Market",
    address: "3 Crispin Place, London E1 6DW",
    date: "Monthly",
    upcomingDates: [
      { date: "18th October 2026", day: "Sunday", time: "2:30pm", bookingUrl: "https://www.alfi.ltd/sip-and-bouquet-london#sip-bouquet-tickets" },
    ],
    time: "18:30pm",
    duration: "60 mins",
    price: 48,
    description: "Spend a relaxed evening at Alfi creating your own seasonal floral arrangement in a stylish Italian setting. Enjoy a complimentary drink, unwind with friends, and let your creativity bloom. Perfect for beginners and experienced flower lovers alike.",
    seasonalDescription: "As the evenings grow darker, join us at Alfi Spitalfields for an October night of flowers, prosecco and a live DJ. Arrange autumnal blooms under the market lights, sip something sparkling, and let the music carry you into the spooky season. A stylish, sociable way to welcome the witching hour.",
    included: ["Your bouquet to take home", "Glass of prosecco", "Live DJ"],
    accent: "#8DA399",
    image: "https://lh3.googleusercontent.com/d/1EkWGa7V1JU7xAbQDpFigeJp54T_JO3qF=w800",
    seasonalImage: "https://lh3.googleusercontent.com/d/1XMEKFhDX2JHitPSf6OZ1FBPrlb33-LfD=w800",
    bookingType: "external",
    bookingUrl: "https://www.alfi.ltd/sip-and-bouquet-london#sip-bouquet-tickets",
    status: "live",
  },
  {
    id: "kings-dog-daycare-wreath-2026",
    name: "Christmas Wreath Making Workshop",
    place: "King's Dog Daycare",
    address: "177 Fulham Road, Chelsea, London SW3 6JW",
    date: "See dates",
    time: "See dates",
    duration: "90 mins",
    price: 70,
    description: "Join us at King's Dog Daycare for a festive wreath-making workshop surrounded by wagging tails and seasonal cheer. You'll be guided through creating your own Christmas wreath from start to finish using fresh seasonal foliage, pinecones, dried fruit and ribbons. Sip a warm drink from the café, meet the daycare dogs, and take your finished wreath home ready to claim its place on your front door. All materials, guidance and dog cuddles included.",
    seasonalDescription: "Get into the festive spirit at King's Dog Daycare in Chelsea. Craft your own Christmas wreath using fresh seasonal foliage, pinecones, dried fruit and festive decorations, all surrounded by the daycare's playful dogs. Sip a warm drink from the café, enjoy puppy cuddles between arranging, and leave with a beautiful handmade wreath for your front door. All materials, guidance and festive dog cheer included.",
    upcomingDates: [
      { date: "28th November 2026", day: "Saturday", time: "1pm", bookingUrl: "https://www.kings.london/events/10" },
      { date: "4th December 2026", day: "Friday", time: "6:30pm", bookingUrl: "https://www.kings.london/events/11" },
    ],
    included: ["Your wreath to take home", "Any drink from café", "Dog treats", "Dog toy", "Puppuccino", "Puppy playtime"],
    accent: "#B8926A",
    image: "https://lh3.googleusercontent.com/d/1vFpZCSy9abXmvNTwpIQc9eqo00ewImid=w800",
    seasonalImage: "https://lh3.googleusercontent.com/d/1vFpZCSy9abXmvNTwpIQc9eqo00ewImid=w800",
    bookingType: "external",
    bookingUrl: "https://www.kings.london/events/10",
    status: "live",
  },
  {
    id: "alfi-wreath-2026",
    name: "Christmas Wreath Making at ALFI",
    place: "Alfi Spitalfields Market",
    address: "3 Crispin Place, London E1 6DW",
    date: "See dates",
    time: "See dates",
    duration: "90 mins",
    price: 75,
    description: "Join us at ALFI for a festive wreath-making workshop, complete with seasonal foliage, Christmas decorations and a glass of prosecco. You'll be guided through creating your own Christmas wreath from start to finish, before taking it home ready to claim its place on your front door. Set in ALFI's stylish Italian surroundings in the heart of Spitalfields Market, this relaxed and sociable workshop is perfect for beginners and experienced crafters alike. All materials, guidance and a glass of prosecco included.",
    seasonalDescription: "Join us at ALFI Spitalfields for a festive wreath-making workshop, complete with seasonal foliage, Christmas decorations and a glass of prosecco. You'll be guided through creating your own Christmas wreath from start to finish, before taking it home ready to claim its place on your front door. Set in ALFI's stylish Italian surroundings in the heart of Spitalfields Market, this relaxed and sociable workshop is perfect for beginners and experienced crafters alike. All materials, guidance and a glass of prosecco included.",
    upcomingDates: [
      { date: "15th November 2026", day: "Sunday", time: "1pm", bookingUrl: "https://www.alfi.ltd/wreathmaking-spitalfields" },
      { date: "21st November 2026", day: "Saturday", time: "3pm", bookingUrl: "https://www.alfi.ltd/wreathmaking-spitalfields" },
      { date: "29th November 2026", day: "Sunday", time: "1pm", bookingUrl: "https://www.alfi.ltd/wreathmaking-spitalfields" },
      { date: "5th December 2026", day: "Saturday", time: "1pm", bookingUrl: "https://www.alfi.ltd/wreathmaking-spitalfields" },
      { date: "13th December 2026", day: "Sunday", time: "1pm", bookingUrl: "https://www.alfi.ltd/wreathmaking-spitalfields" },
    ],
    included: ["Your wreath to take home", "Glass of prosecco", "Seasonal foliage and decorations"],
    accent: "#8DA399",
    image: "https://lh3.googleusercontent.com/d/1vFpZCSy9abXmvNTwpIQc9eqo00ewImid=w800",
    seasonalImage: "https://lh3.googleusercontent.com/d/1vFpZCSy9abXmvNTwpIQc9eqo00ewImid=w800",
    bookingType: "external",
    bookingUrl: "https://www.alfi.ltd/wreathmaking-spitalfields",
    status: "live",
  },
  {
    id: "cups-pups-cafe-2026-08-23",
    name: "Flower Arranging Workshop",
    place: "Cups & Pups Café",
    address: "18 London Road, Dunton Green, Sevenoaks, TN13 2UE",
    date: "Monthly",
    upcomingDates: [],
    time: "2pm",
    duration: "90 mins",
    price: 45,
    description: "Spend your afternoon surrounded by blooms and good company. Guided by us and the café dogs, every stem is chosen safe for curious noses and wagging tails.",
    included: ["Your bouquet to take home", "Drinks from the café", "Surrounded by pugs"],
    accent: "#C4A2B0",
    image: "https://lh3.googleusercontent.com/d/1Q22XMRxPBNy89OjFVO2VjiYLwwWYv14S=w800",
    bookingType: "stripe",
    status: "live",
  },
  {
    id: "cups-pups-cafe-2026-08-23",
    name: "Flower Arranging Workshop",
    place: "Purrfect Café",
    address: "11, Imperial Arcade, Brighton and Hove, Brighton BN1 3EA",
    date: "30th October 2026",
    upcomingDates: [
      { date: "30th October 2026", day: "Friday", time: "6:30pm", bookingUrl: "https://ecom.roller.app/purrfectspace/artworkshop/en/product/1315239?date=2026-07-25" },
    ],
    time: "6:30pm",
    duration: "120 mins",
    price: 45,
    description: "Join us at Purrfect Café in Brighton for a relaxed evening of flower arranging. Design your own bouquet with seasonal stems, all non-toxic and cat-approved. Sip a drink from the café, meet the resident rescue cats, and leave with something beautiful.",
    seasonalDescription: "Join us at Purrfect Café in Brighton for a spine-tingling evening of flower arranging. Design your own Halloween bouquet with seasonal stems and spooky accents, all non-toxic and cat-approved. Sip a drink from the café, meet the resident rescue cats, and leave with a creation to die for.",
    included: ["Your bouquet to take home", "Drinks from the café", "Meet the resident rescue cats"],
    accent: "#C4A2B0",
    image: "https://lh3.googleusercontent.com/d/1VwBn0d7xmKWaOJrVE9HSQsKF08CPOynK=w800",
    seasonalImage: "https://lh3.googleusercontent.com/d/1YMwLFfooDcskdkWPti7QO_qSrnCqNc_p=w800",
    bookingType: "external",
    bookingUrl: "https://ecom.roller.app/purrfectspace/artworkshop/en/product/1315239?date=2026-07-25",
    status: "live",
  },
];

// Parse a workshop date string like "10th October 2026" or "11 September 2026" into a Date.
function parseWorkshopDate(str) {
  const cleaned = String(str).replace(/(\d+)(st|nd|rd|th)\b/i, "$1");
  const d = new Date(cleaned);
  return isNaN(d.getTime()) ? null : d;
}

// A date is "past" if the full day has ended (midnight of the next day).
export function isDatePast(dateStr) {
  const d = parseWorkshopDate(dateStr);
  if (!d) return false;
  const endOfDay = new Date(d);
  endOfDay.setHours(0, 0, 0, 0);
  endOfDay.setDate(endOfDay.getDate() + 1);
  return new Date() >= endOfDay;
}

// Return only the upcoming (non-past) date rows for a workshop.
export function upcomingDates(workshop) {
  return (workshop.upcomingDates || []).filter((d) => !isDatePast(d.date));
}

export const upcomingWorkshops = () =>
  WORKSHOPS.filter((w) => w.status !== "past" && upcomingDates(w).length > 0);
export const redeemableWorkshops = () =>
  WORKSHOPS.filter((w) => w.status !== "past" && upcomingDates(w).length > 0);

// Workshops that have at least one October date (used by the Halloween seasonal page).
export const octoberWorkshops = () =>
  WORKSHOPS.filter((w) => (w.upcomingDates || []).some((d) => /\boct(ober)?\b/i.test(d.date)));
